import { createContainer } from 'usage-tracker-multi';
import events from 'MeetingsLib/events.yaml';
import { MEETINGS_APP_NAME } from 'MeetingsBase/constants/strings';
// @bend-expect quartz-no-create-browser-history
import { createBrowserHistory } from 'quartz-routing/react-router';
const HUBSPOT_INTERNAL_PORTAL = 53;
const DEFAULT_LOCALE = 'en';
let tracker = null;
let screen = 'public';
const DEFAULT_CONTAINER_OPTS = {
  // We use the `history` package as it allows us to integrate to 3rd party Application
  // history states. This is mostly useful for Anonymous Tracker and to keep states in sync
  history: createBrowserHistory()
};
export function initializeMeetingsLibTracker(email, portalId, embedded, locale) {
  screen = embedded ? 'embedded' : 'public';
  const {
    createTracker
  } = createContainer({
    history: DEFAULT_CONTAINER_OPTS.history
  });
  if (portalId === HUBSPOT_INTERNAL_PORTAL) {
    var _I18n;
    tracker = createTracker({
      events,
      trackerType: 'public',
      properties: {
        namespace: MEETINGS_APP_NAME,
        hubId: portalId,
        lang: locale || window.I18n ? (_I18n = window.I18n) === null || _I18n === void 0 ? void 0 : _I18n.locale : DEFAULT_LOCALE,
        screen
      }
    });
  } else {
    var _I18n2;
    tracker = createTracker({
      events,
      trackerType: 'anonymous',
      properties: {
        namespace: MEETINGS_APP_NAME,
        email,
        hubId: portalId,
        lang: locale || window.I18n ? (_I18n2 = window.I18n) === null || _I18n2 === void 0 ? void 0 : _I18n2.locale : DEFAULT_LOCALE,
        screen
      }
    });
  }
  return tracker;
}
export function track(eventKey, eventProperties = {}) {
  if (tracker) {
    tracker.track(eventKey, Object.assign({
      screen
    }, eventProperties));
  }
}